import React, { useState } from 'react';
import { Modal, Button, Dropdown } from 'react-bootstrap';

const AddCustomQuestionModal = ({ show, onHide, onSave }) => {
  const [questionLabel, setQuestionLabel] = useState('');
  const [placeholder, setPlaceholder] = useState('');
  const [inputType, setInputType] = useState('Short Text');
  const [isMandatory, setIsMandatory] = useState(false);

  const handleSave = () => {
    onSave({ questionLabel, placeholder, inputType, isMandatory });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Add Custom Question</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Question Label</label>
          <input
            type="text"
            className="form-control"
            value={questionLabel}
            onChange={(e) => setQuestionLabel(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Placeholder</label>
          <input
            type="text"
            className="form-control"
            value={placeholder}
            onChange={(e) => setPlaceholder(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Input Type</label>
          <Dropdown onSelect={(type) => setInputType(type)}>
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              {inputType}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="Email">Email</Dropdown.Item>
              <Dropdown.Item eventKey="Phone">Phone</Dropdown.Item>
              <Dropdown.Item eventKey="Address">Address</Dropdown.Item>
              <Dropdown.Item eventKey="Short Text">Short Text</Dropdown.Item>
              <Dropdown.Item eventKey="Number">Number</Dropdown.Item>
              <Dropdown.Item eventKey="Long Text">Long Text</Dropdown.Item>
              <Dropdown.Item eventKey="Select">Select</Dropdown.Item>
              <Dropdown.Item eventKey="MultiSelect">MultiSelect</Dropdown.Item>
              <Dropdown.Item eventKey="Multiple Emails">Multiple Emails</Dropdown.Item>
              <Dropdown.Item eventKey="Checkbox Group">Checkbox Group</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="mandatory"
            checked={isMandatory}
            onChange={() => setIsMandatory(!isMandatory)}
          />
          <label className="form-check-label" htmlFor="mandatory">
            Mandatory
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="success" onClick={handleSave}>
          Save Question
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCustomQuestionModal;
